module.exports = __webpack_public_path__ + "static/img/celoscope-38.93cc9c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-38.jpg
// module id = vXqn
// module chunks = 51